import { render, staticRenderFns } from "./MegaBurgerMenu.vue?vue&type=template&id=1a8656e7&"
import script from "./MegaBurgerMenu.vue?vue&type=script&lang=js&"
export * from "./MegaBurgerMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a8656e7')) {
      api.createRecord('1a8656e7', component.options)
    } else {
      api.reload('1a8656e7', component.options)
    }
    module.hot.accept("./MegaBurgerMenu.vue?vue&type=template&id=1a8656e7&", function () {
      api.rerender('1a8656e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/MegaBurgerMenu.vue"
export default component.exports